module.exports = __webpack_public_path__ + "static/media/icon-handshake.09bc3f09.svg";